module.exports = __webpack_public_path__ + "static/media/left-arrow.7cde0e94.svg";